import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from 'src/app/header/header.module';
import { RouterModule } from '@angular/router';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { NavMenuDesktopComponent } from './nav-menu-desktop/nav-menu-desktop.component';
import { NavMenuMobileComponent } from './nav-menu-mobile/nav-menu-mobile.component';



@NgModule({
	declarations: [
		NavMenuComponent, 
		NavMenuDesktopComponent, 
		NavMenuMobileComponent	
	],
	imports: [
		CommonModule,
		RouterModule,
		HeaderModule
	],
	exports : [NavMenuComponent]
})
export class NavigationMenuModule { }
